import { FeatureFlag } from "../../feature-flags";
import {
  useOnboardingFeatureEnabled,
  type OnboardingFeatureEnabledResult,
} from "./useOnboardingFeatureEnabled";

/**
 * Composite gate for Company Configurations and Bulk create companies.
 *
 * Both flows share `enable-company-config` (plus parent `enable-onboarding`)
 * because bulk create depends on published company-config templates.
 */
export function useCompanyConfigEnabled(): OnboardingFeatureEnabledResult {
  return useOnboardingFeatureEnabled(FeatureFlag.EnableCompanyConfig);
}
